import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },
  fetchEstimatedHarvest(organization_id, estimated_harvest_id) {
    return RequesterV1.get(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/fetch_estimated_harvest/${estimated_harvest_id}`
    );
  },
  fetchProducers(organization_id) {
    return RequesterV1.get(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/fetch_producers`
    );
  },
  fetchCropFields(organization_id, harvest_process_id, producer_id) {
    return RequesterV1.get(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/fetch_crop_fields/${harvest_process_id}/${producer_id}`
    );
  },
  fetchHarvestProcessCropPackages(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/fetch_harvest_process_crop_packages/${harvest_process_id}`
    );
  },
  fetchHarvestProcessCropSizeGroups(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/fetch_harvest_process_crop_size_groups/${harvest_process_id}`
    );
  },
  create(organization_id, harvest_process_id, estimated_harvest) {
    return RequesterV1.post(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/create/${harvest_process_id}`,
      { estimated_harvest }
    );
  },
  update(organization_id, estimated_harvest_id, estimated_harvest) {
    return RequesterV1.post(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/update/${estimated_harvest_id}`,
      { estimated_harvest }
    );
  },
  destroy(organization_id, estimated_harvest_id) {
    return RequesterV1.delete(
      `organization/projections/estimated_harvest/manage_estimated_harvest/${organization_id}/destroy/${estimated_harvest_id}`
    );
  }
};
